import type { FieldPath, FieldValues } from "react-hook-form";
import { CdcSelectField, type CdcSelectFieldProps } from "./cdc-field-helpers";
import { getCdcBusinessTypeOptions } from "@/i18n/cdc-options";

export type CdcTypeOfBusinessFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<CdcSelectFieldProps<TFieldValues, TName>, "fieldKey" | "options">;

export function CdcTypeOfBusinessField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  locale,
  ...rest
}: Readonly<CdcTypeOfBusinessFieldProps<TFieldValues, TName>>) {
  return (
    <CdcSelectField
      {...rest}
      fieldKey="businessType"
      locale={locale}
      options={getCdcBusinessTypeOptions(locale)}
    />
  );
}
